import React, { useContext, useEffect, useState } from "react";

import { AuthContext } from "./accounts/AccountsReducer";
import Header from './components/Header';
import { loadUser } from "./accounts/AccountsUtils";
import { SystemErrorContext } from './components/SystemError';

function Home({ incident }) {

  const path = window.location.pathname;

  // Initial state.
  const { dispatch, state } = useContext(AuthContext);
  // Hook for initializing data.
  useEffect(() => {
    // Reload user data after incident selection.
    loadUser({state, dispatch, path});
  }, [incident]);

  const watchdutyUrl = "https://app.watchduty.org/#/i/" + state.incident.watchduty_map_id;

  return (
    <>
    <span className="rounded-top">
      <Header version={state.user.version}>Home - {state.organization.name}</Header>
      {/* state.incident.watchduty_map_id ? 
      <div style={{height:"635px" }}>
        <iframe
          src={watchdutyUrl}
          width="100%"
          height="100%"
          scrolling="no"
          frameBorder="0"
          style={{
            width: "100%"
          }}
        >
        </iframe>
      </div>
      : ""*/}
      <div style={{whiteSpace:"pre-line"}}>
        <h4>{state.incident.description || "Welcome to Shelterly"}</h4>
      </div>
    </span>
    </>
  );
}

export default Home;
